import { Image, Platform } from 'react-native';

export async function getImageDimensionsFromUri(
  uri: string
): Promise<{ readonly width: number; readonly height: number }> {
  if (Platform.OS === 'web') {
    return new Promise((resolve, reject) => {
      const img = new window.Image();
      img.onload = () => {
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      };
      img.onerror = () => {
        reject(new Error('Could not read image dimensions'));
      };
      img.src = uri;
    });
  }

  return new Promise((resolve, reject) => {
    Image.getSize(
      uri,
      (width, height) => {
        resolve({ width, height });
      },
      error => {
        reject(error);
      }
    );
  });
}
